/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {PeriodSummaryModel} from '../../../models/period/period-summary/period-summary.model';
import {PeriodInfoModel} from '../period-info.model';

export class PeriodsInfoChartMapper {

    static fromPeriodSummaryModelArrayToPeriodInfoModelArray(input: PeriodSummaryModel[]):
            PeriodInfoModel[] {
        return input?.map((element) => PeriodsInfoChartMapper
                .fromPeriodSummaryModelToPeriodInfoModel(element));
    }

    static fromPeriodSummaryModelToPeriodInfoModel(input: PeriodSummaryModel):
            PeriodInfoModel{

        let model: PeriodInfoModel;
        if (input != null) {
            model = {
                code: input.code,
                timePeriod: input.timePeriod,
                type: input.periodType,
                totalAmount: input.totalAmount
            };
        }
        return model;
    }
}

